const isLocalEnv = () => window.location.hostname.includes('localhost');

export const getIntegrationServiceBaseUrl = () => {
  if (isLocalEnv() && process.env.CONNECT_INTEGRATION_SERVICE) {
    return 'https://core.dev/dp/public/v1';
  }

  return '/dp/public/v1';
};
